export default {
	name: "assessment",
	title: "Assessment",
	icon: require("./content-icon.svg"),
	category: "training"
}
